var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-transfer',{attrs:{"data-source":_vm.mockData,"list-style":{
    width: '235px',
    height: '300px',
  },"target-keys":_vm.targetKeys,"render":_vm.renderItem},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }